'use client'

import type { ReactNode } from 'react'

import '../sections.css'

import parse from 'html-react-parser'

import useStore from '@/stores/Store'

interface JumbotronBizProps {
  badgeText?: ReactNode
  title: string
  buttonText?: ReactNode
  footNotes?: ReactNode
  backgroundImage?: string
  uniqueBg?: string
}

function JumbotronBiz({
  badgeText,
  title,
  buttonText,
  footNotes,
  backgroundImage,
  uniqueBg
}: JumbotronBizProps) {
  const { formRef } = useStore()

  const backgroundStyle = backgroundImage
    ? {
        backgroundImage: `url(${backgroundImage}), url(${uniqueBg})`,
        backgroundPosition: `bottom right, bottom center`,
        backgroundSize: `contain, cover`,
        backgroundRepeat: 'no-repeat, no-repeat',
        minHeight: '40vh'
      }
    : {}

  return (
    // <div className="jumbotron">
    <div className="background-color-biz">
      <div className="background-img-biz" style={backgroundStyle}>
        <div className="container">
          <div className="jumbotron-container">
            <div className="jumbotron-title col-xl-2">{badgeText}</div>
            <div className="jumbotron-subtitle col-xl-6 text-center text-md-start">
              {parse(title)}
            </div>
            {buttonText && (
              <button
                className="btn btn-primary btn-lg applybtn"
                type="button"
                onClick={() => {
                  if (formRef.current) {
                    const offset = 410 // Adjust this value as needed
                    const topPosition =
                      formRef.current.getBoundingClientRect().top + window.pageYOffset - offset
                    window.scrollTo({
                      top: topPosition,
                      behavior: 'smooth'
                    })
                  }
                  // formRef?.current?.scrollIntoView({ block: "end" })
                }}
              >
                {buttonText}
              </button>
            )}
            {footNotes && (
              <div className="jumbotron-note">
                <i className="bi bi-shield" style={{ margin: '5px' }}></i>
                {footNotes}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    // </div>
  )
}

export default JumbotronBiz
